import http from "../shared/axios";
import { Audit_Log } from "../shared/ServiceCommonEndpoints";

export default class AuditLogging {

    static sendLog(activityType, identifierId, isSuccessful, additionalInfo) {
        http.post(Audit_Log, {
            data: {
                activityType,
                identifierId,
                isSuccessful,
                additionalInfo,
            },
            action: "auditLog",
            type: "Swift App"
        },
            {
                headers: {
                    "IDENTIFIER_1": identifierId,
                    "IDENTIFIER_2": localStorage.getItem("visitorID")
                }
            });
    }
}